import React from "react";

const DeleteAccountInfo = () => {
  return (<div style={styles.container}> <h1 style={styles.heading}>Delete Account Information</h1>
    <p style={styles.text}>
      To permanently delete your <strong>TeamTrack</strong> account and all associated data,
      please follow the steps below:
    </p>

    <ol style={styles.list}>
      <li style={styles.step}>Open the TeamTrack app on your device.</li>
      <li style={styles.step}>Log in using your registered account credentials.</li>
      <li style={styles.step}>Open the side menu drawer (top-left corner).</li>
      <li style={styles.step}>Tap on the “Delete Account” button at the bottom.</li>
      <li style={styles.step}>
        Confirm the action when prompted. Once confirmed, your account and all related data
        (work logs, location history, expenses, etc.) will be permanently deleted from our
        servers.
      </li>
    </ol>

    <p style={styles.text}>
      <strong>This deletion process is irreversible.</strong> Once your account is deleted,
      your data cannot be recovered.
    </p>

    <p style={styles.text}>
      For any issues or to request deletion manually, contact us at{" "}
      <span style={styles.highlight}>Assistenza@elmecelettronica.com</span>.
    </p>
  </div>
  );
};

const styles = {
  container: {
    maxWidth: "700px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#ffffff",
    color: "#333",
    lineHeight: "1.6",
  },
  heading: {
    color: "#d32f2f",
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "20px",
  },
  text: {
    fontSize: "16px",
    marginBottom: "16px",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "20px",
  },
  step: {
    marginBottom: "10px",
  },
  highlight: {
    color: "#d32f2f",
    fontWeight: "600",
  },
};

export default DeleteAccountInfo;
